(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["apgo-inview-video"] && !Shopify.designMode) return;
  try {
    (function () {
    var STEPS = ['3s', '10s', 'half', 'complete'];
    var STEP_EVENT = { '3s': 'apgo_video_view', '10s': 'apgo_video_10s', half: 'apgo_video_half', complete: 'apgo_video_complete' };

    // Sources go in when the video is first on screen (see the doc).
    function attach(video) {
      if (video.dataset.apgoAttached) return;
      video.dataset.apgoAttached = '1';
      var sources = video.querySelectorAll('source[data-src]');
      sources.forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      if (sources.length) video.load();
    }

    function publish(video, name, extra) {
      var box = video.closest('[data-apgo-inview-video]');
      var payload = {
        video_id: box.dataset.videoId,
        product_id: box.dataset.productId,
        product_handle: box.dataset.productHandle,
        product_title: box.dataset.productTitle,
        video_duration: Math.round(video.duration) || undefined,
        country: window.Shopify && Shopify.country,
        page_path: location.pathname
      };
      Object.keys(extra || {}).forEach(function (key) { payload[key] = extra[key]; });
      try {
        var analytics = window.Shopify && Shopify.analytics;
        if (analytics && analytics.publish) {
          var sent = analytics.publish(name, payload);
          if (sent && sent.catch) sent.catch(function () {});
        }
        if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      } catch (error) {}
    }

    // Furthest step per product on the cart attribute apgo_video_watched
    // ("handle=step,..."). Writes go one after another so 3s and 10s
    // cannot overwrite each other.
    var cartWrites = Promise.resolve();
    function markCart(handle, step) {
      if (!handle) return;
      var rank = STEPS.indexOf(step);
      var key = 'apgoVideoWatched:' + handle;
      try {
        if (STEPS.indexOf(sessionStorage.getItem(key)) >= rank) return;
        sessionStorage.setItem(key, step);
      } catch (error) {}
      cartWrites = cartWrites
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var seen = {};
          ((cart.attributes || {}).apgo_video_watched || '').split(',').forEach(function (pair) {
            var parts = pair.split('=');
            if (parts[0]) seen[parts[0]] = parts[1] || '3s';
          });
          if (STEPS.indexOf(seen[handle]) >= rank) return;
          seen[handle] = step;
          var value = Object.keys(seen).map(function (h) { return h + '=' + seen[h]; }).join(',');
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { apgo_video_watched: value } })
          });
        })
        .catch(function () {});
    }

    // "On screen": half of the video showing, or, for one taller than the
    // screen, half of the screen filled by it. A ratio threshold alone
    // never fires for a tall portrait video on a wide page.
    function onScreen(entry) {
      var screen = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;
      var need = Math.min(entry.boundingClientRect.height, screen) / 2;
      return entry.intersectionRect.height >= need && need > 0;
    }

    function play(video) {
      video.dataset.apgoSelfPlay = '1';
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () { delete video.dataset.apgoSelfPlay; });
    }

    var observer = 'IntersectionObserver' in window && new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (onScreen(entry)) {
            attach(video);
            if (video.paused && !video.dataset.apgoUserPaused) play(video);
          } else if (!video.paused) {
            video.dataset.apgoSelfPause = '1';
            video.pause();
          }
        });
      },
      { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }
    );

    function watch() {
      document.querySelectorAll('[data-apgo-inview-video] video').forEach(function (video) {
        if (video.dataset.apgoInview) return;
        video.dataset.apgoInview = '1';
        // Set as a property too: some browsers only autoplay when it is.
        video.muted = true;
        if (!observer) { attach(video); return; }

        var handle = video.closest('[data-apgo-inview-video]').dataset.productHandle;
        var sent = {};
        var watched = 0;
        var last = null;
        function once(name, extra) {
          if (sent[name]) return;
          sent[name] = true;
          publish(video, name, extra);
        }
        function step(name) {
          if (sent[STEP_EVENT[name]]) return;
          once(STEP_EVENT[name], { watched_seconds: Math.round(watched) });
          markCart(handle, name);
        }

        video.addEventListener('pause', function () {
          if (video.dataset.apgoSelfPause) delete video.dataset.apgoSelfPause;
          else if (!video.ended) video.dataset.apgoUserPaused = '1';
        });
        video.addEventListener('play', function () {
          delete video.dataset.apgoUserPaused;
          if (video.dataset.apgoSelfPlay) delete video.dataset.apgoSelfPlay;
          else if (!video.dataset.apgoRestart) once('apgo_video_play_click');
          delete video.dataset.apgoRestart;
        });
        video.addEventListener('volumechange', function () {
          if (!video.muted && video.volume > 0) once('apgo_video_sound_on');
        });
        video.addEventListener('webkitbeginfullscreen', function () { once('apgo_video_fullscreen'); });
        document.addEventListener('fullscreenchange', function () {
          if (document.fullscreenElement === video) once('apgo_video_fullscreen');
        });
        video.addEventListener('seeking', function () { last = null; });
        video.addEventListener('timeupdate', function () {
          var now = video.currentTime;
          // Played time only: small steps between updates, not jumps.
          if (last !== null && now > last && now - last < 1.5) watched += now - last;
          last = now;
          if (watched >= 3) step('3s');
          if (watched >= 10) step('10s');
          if (video.duration && now / video.duration >= 0.5) step('half');
        });
        // Starts over by hand: the loop attribute would rule out HLS.
        video.addEventListener('ended', function () {
          step('complete');
          video.dataset.apgoRestart = '1';
          video.currentTime = 0;
          play(video);
        });
        observer.observe(video);
      });
    }

    // Not before the page itself has loaded: on desktop the bundles' video
    // sits half in the first screen, and must not hold up the page's own
    // images and scripts.
    if (document.readyState === 'complete') watch();
    else window.addEventListener('load', watch);
    document.addEventListener('shopify:section:load', watch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    /*
    Per-order limit per option on the cart page (snippets/apgo-max-per-order.liquid,
    e.g. Pocket-Friendly Deals: 3). The quantity box of such a line carries
    max and data-apgo-max-per-order (snippets/quantity-selector.liquid); here
    the shopper is told why + stops there, with the same toast the product
    page shows (styles: snippets/apgo-cart-toast.liquid). Bound once: this
    block ships once per page however often the snippet renders.
  */
  (function () {
    if (window.apgoMaxPerOrderCartBound) return;
    window.apgoMaxPerOrderCartBound = true;

    function limitToast(max, title, sub) {
      document.querySelectorAll('.apgo-cart-success-toast').forEach(function (n) { n.remove(); });
      var el = document.createElement('div');
      el.className = 'apgo-cart-success-toast apgo-cart-success-toast--error';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'assertive');
      el.innerHTML = ''
        + '<span class="apgo-cart-success-toast__check" aria-hidden="true">!</span>'
        + '<div class="apgo-cart-success-toast__body">'
        + '  <span class="apgo-cart-success-toast__title"></span>'
        + '  <span class="apgo-cart-success-toast__sub"></span>'
        + '</div>'
        + '<button type="button" class="apgo-cart-success-toast__close" aria-label="Close">'
        + '  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
        + '</button>';
      el.querySelector('.apgo-cart-success-toast__title').textContent = title || 'Limit ' + max + ' per item, per order';
      el.querySelector('.apgo-cart-success-toast__sub').textContent = sub || 'You already have ' + max + ' of this option in your cart.';
      el.querySelector('.apgo-cart-success-toast__close').addEventListener('click', function () { el.remove(); });
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('apgo-cart-success-toast--visible'); });
      setTimeout(function () {
        el.classList.remove('apgo-cart-success-toast--visible');
        setTimeout(function () { el.remove(); }, 380);
      }, 4200);
    }

    function limitOf(input) {
      return parseInt(input && input.getAttribute('max'), 10) || 0;
    }

    /* + pressed while the line is already at the limit. On window, capture
       phase: the theme's own delegated handlers (assets/component.js) sit on
       document, capture phase, and would step the value up first. */
    window.addEventListener('click', function (e) {
      var btn = e.target instanceof Element ? e.target.closest('quantity-selector-component button[name="plus"]') : null;
      if (!btn) return;
      var input = btn.closest('quantity-selector-component').querySelector('input[data-apgo-max-per-order]');
      var max = limitOf(input);
      if (max && (parseInt(input.value, 10) || 0) >= max) limitToast(max);
    }, true);

    /* A typed number over the limit (the box has already snapped back). */
    document.addEventListener('apgo:max-per-order', function (e) {
      var max = limitOf(e.target);
      if (max) limitToast(max);
    });

    /* Lines already over the limit (2026-10-06): "Buy again" in the customer
       account copies an old order's quantities into the cart and lands here,
       and a cart filled before a limit was lowered keeps its quantities;
       three RM1 wiper fluids per order got through both ways. Each limited
       line prints a [data-apgo-line-limit] mark; over the limit, the cart is
       set back to it, the page reloads and the toast says what changed.
       Checkout itself still does not check. */
    var FIXED_KEY = 'apgoMaxPerOrderFixed';

    function overLimitFix() {
      var lines = {};
      /* The drawer and the cart page can both list the same line. */
      document.querySelectorAll('[data-apgo-line-limit]').forEach(function (m) {
        lines[m.getAttribute('data-key')] = m;
      });
      var byVariant = {};
      Object.keys(lines).forEach(function (key) {
        var m = lines[key];
        var variant = m.getAttribute('data-variant');
        (byVariant[variant] = byVariant[variant] || []).push({
          key: key,
          qty: parseInt(m.getAttribute('data-qty'), 10) || 0,
          max: parseInt(m.getAttribute('data-max'), 10) || 0,
          title: m.getAttribute('data-title') || ''
        });
      });
      var updates = {};
      var notes = [];
      Object.keys(byVariant).forEach(function (variant) {
        var group = byVariant[variant];
        var max = group[0].max;
        var excess = group.reduce(function (n, line) { return n + line.qty; }, 0) - max;
        if (!max || excess <= 0) return;
        for (var i = group.length - 1; i >= 0 && excess > 0; i--) {
          var cut = Math.min(group[i].qty, excess);
          updates[group[i].key] = group[i].qty - cut;
          excess -= cut;
        }
        notes.push({ title: group[0].title, max: max });
      });
      return notes.length ? { updates: updates, notes: notes } : null;
    }

    function fixOverLimit() {
      var fix = overLimitFix();
      if (!fix) return;
      /* Tried a moment ago and still over: stop rather than reload in a loop. */
      try {
        if (Date.now() - (parseInt(sessionStorage.getItem(FIXED_KEY + 'At'), 10) || 0) < 15000) return;
        sessionStorage.setItem(FIXED_KEY + 'At', String(Date.now()));
      } catch (e) {}
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: fix.updates })
      }).then(function (r) {
        if (!r.ok) return;
        try { sessionStorage.setItem(FIXED_KEY, JSON.stringify(fix.notes)); } catch (e) {}
        window.location.reload();
      }).catch(function () {});
    }

    function showFixedNote() {
      var notes = null;
      try {
        notes = JSON.parse(sessionStorage.getItem(FIXED_KEY) || 'null');
        sessionStorage.removeItem(FIXED_KEY);
      } catch (e) {}
      if (!notes || !notes.length) return;
      limitToast(
        notes[0].max,
        notes.length === 1 ? null : 'Per-order limits',
        'We changed ' + notes.map(function (n) { return n.title + ' to ' + n.max; }).join(', ') + ' in your cart.'
      );
    }

    function start() {
      showFixedNote();
      fixOverLimit();
      /* The drawer re-renders its lines after every cart change. */
      var timer = 0;
      var watch = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(fixOverLimit, 300);
      });
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        watch.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-qty'] });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
